export const LOCALES = {
  en: 'English',
  ko: '한국어',
  pt: 'Português',
};
